import { ApiClient, ApiResponse, ServiceBase } from './api'

export interface MarkProgress {
  markId: number
  markNumber: string
  houseBillId: number
  houseBlNumber: string
  houseBillNumber: string
  percentage: number
  summary: {
    total: number // 总数
    scanned: number // 已扫
    palletized: number // 已打托
  }
  isCompleted: boolean
  canQuickPallet: boolean
  canMixedPallet: boolean
}

export interface ScanRecord {
  barcode: string
  operatorName: string
  scannedCount: number
  markId: number
  markNumber: string
  createdAt: string
  updatedAt: string
}

export interface PendingPallet {
  id: number
  palletCode: string
  houseBillId: number
  totalBoxes: number
  marksNumber: string
  marksCount: number
  status: string
  statusDisplay: string
  entryDate: string | null
  exitDate: string | null
  createdAt: string
  updatedAt: string
  warehousePositionId: number | null
  positionCode: string | null
  houseBlNumber: string
  canDisassemble: boolean
  cargoMarks: PalletCargoMark[]
}

export interface PalletsGroup {
  houseBillId: number
  houseBlNumber: string
  pallets: PendingPallet[]
}

export interface CargoMarksGroup {
  houseBillId: number
  houseBlNumber: string
  marks: MarkProgress[]
}

export interface InboundProgressScheam {
  masterBillId: number
  masterBlNumber: string
  cargoMarkProgress?: MarkProgress
  cargoMarksProgress: MarkProgress[]
  cargoMarksGroup: CargoMarksGroup[]
  records: ScanRecord[]
  pallets: PendingPallet[]
  palletsGroup: PalletsGroup[]
}

// 数据类型定义
export interface ScanRequest {
  barcode: string
  quantity?: number // 可选的数量参数，用于批量扫描
}

export interface ScanResponse {
  markId: number
  barcode: string
  scanned: number
}

export interface PalletCargoMark {
  id: number
  cargoNumber: string // todo: 有兼容问题
  markCode: string
  totalPackages: number // todo: 有兼容问题
  totalBoxes: number
  scannedPackages: number
}

export interface CreatedPalletResponse {
  palletId: number
  palletNumber: string
  palletCode: string
  palletTotalPackages: number
  houseBillNumber: string
  cargoMarks: PalletCargoMark[]
}

export interface CreateMixedPalletRequest {
  houseBillId: number
  markIds: number[]
}

export class InboundV2Service extends ServiceBase {
  constructor(client: ApiClient) {
    super(client, '/v2/inbound')
  }

  // 入库扫描条码
  async scan(masterBillId: number, request: ScanRequest) {
    return this.post<ApiResponse<ScanResponse>>(
      `/${masterBillId}/scan`,
      request
    )
  }

  // 创建托盘
  async createPallet(masterBillId: number, markId: number) {
    return this.post<ApiResponse<CreatedPalletResponse>>(
      `/${masterBillId}/create-pallet`,
      {
        markId: markId
      }
    )
  }

  // 创建混合托盘
  async createMixedPallet(masterBillId:number, request: CreateMixedPalletRequest) {
    return this.post<ApiResponse<CreatedPalletResponse>>(
      `/${masterBillId}/create-mixed-pallet`,
      request
    )
  }

  // 拆柜进度
  async progress(masterBillId: number, markId?: number) {
    return this.get<ApiResponse<InboundProgressScheam>>(
      `/${masterBillId}/scan-progress`,
      {
        params: {
          markId
        }
      }
    )
  }

  // 拆柜监控
  async monitor() {
    return this.get<ApiResponse<InboundProgressScheam[]>>(`/monitor`)
  }

  // 清空已扫
  async clearScannedByMarkId(masterBillId: number, markId?: number) {
    return this.delete<ApiResponse<ScanResponse>>(`/${masterBillId}/scanned`, {
      params: {
        markId
      }
    })
  }
}
